// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1kU7r","header":"Messages_header__37mIs"};